export const sliceName = 'metric';

export const getMetricActionType = `${sliceName}/getMetric`;

export const getMetricFiltersActionType = `${sliceName}/getMetricFilters`;

export const addToMailingListActionType = `${sliceName}/addToMailingList`;

export const deleteFromMailingListActionType = `${sliceName}/deleteFromMailingList`;
